export const roundDecimal = (value: number, precision = 2): number => {
  return (
    Math.round((value + Number.EPSILON) * 10 ** precision) / 10 ** precision
  );
};
